"use client"
import { emptyTokenAndSelectionMetadata } from "@/actions/cookies/centraDefaultSessionFromCookies"
import getCentraSessionFromCookies from "@/actions/cookies/getCentraSessionFromCookies"
import { keepSelection } from "@/actions/selection/keep-selection"
import useEcommerceStore from "@/app/(site)/contexts/ecommerce/store"
import logger from "@/lib/logger/logger-init"
import { setUserPropertiesEvent } from "@/lib/utils/tracking/gtmEvents"
import { CheckoutAPISelection } from "@/types/centra/checkout-api/selection/get-selection"
import { RequiredTokenAndSelectionMetadata } from "@/types/cookie-types"
import { useQuery } from "@tanstack/react-query"
import { useEffect } from "react"

export function UserPropertiesInitializer() {
    const { data } = useQuery({
        queryKey: ["selection"],
        queryFn: () => keepSelection(),
        refetchOnWindowFocus: false
    })
    let checkoutApiSelection: CheckoutAPISelection | undefined
    if (data?.success) {
        checkoutApiSelection = data?.data?.checkoutApiSelection
    }

    const setCentraSession = useEcommerceStore(state => state.setCentraSession)
    useEffect(() => {
        const getCentraSessionCookieAndSetFilteredLanguages = async () => {
            let centraSessionFromCookies: RequiredTokenAndSelectionMetadata =
                emptyTokenAndSelectionMetadata
            try {
                centraSessionFromCookies = await getCentraSessionFromCookies()
            } catch (error) {
                logger.error(
                    "Error fetching Centra session from cookies in UserPropertiesInitializer",
                    error
                )
            }

            setCentraSession(centraSessionFromCookies ?? "")
        }

        getCentraSessionCookieAndSetFilteredLanguages()
    }, [setCentraSession])

    useEffect(() => {
        if (
            checkoutApiSelection?.location?.country &&
            checkoutApiSelection?.selection?.language
        ) {
            setUserPropertiesEvent(
                checkoutApiSelection?.location?.country,
                checkoutApiSelection?.selection?.language
            )
        }
    }, [
        checkoutApiSelection?.location?.country,
        checkoutApiSelection?.selection?.language
    ])

    return null
}
